const Data = {
  productItems: [
    {
      id: 1,
      discount: 50,
      cover: "./images/flash/Copy_of_aa_high_Marine_Plywood__4_841.28-removebg-preview-removebg-preview.png",
      name: "High Marine Plywood",
      price: 4841,
      supplier: "Supplier 1",
      address: "Sampaloc, Apalit",
      category: "Masonry",
    },
    {
      id: 2,
      discount: 40,
      cover: "./images/flash/Copy of bb high_grade_cement-removebg-preview.png",
      name: "High Grade Cement",
      price: 235,
      supplier: "Supplier 1",
      address: "Sampaloc, Apalit",
      category: "Masonry",
      
    },
    {
      id: 3,
      discount: 40,
      cover: "./images/flash/Copy of cc high__1_-removebg-preview.png",
      name: "Galvanized Steel/Iron Roof",
      price: 200,
      supplier: "Supplier 1",
      address: "Sampaloc, Apalit",
      category: "Steel",
    },
    {
      id: 4,
      discount: 40,
      cover: "./images/flash/Untitled_design-removebg-preview.png",
      name: "Coco Lumber 2 x 3 x 8",
      price: 125,
      supplier: "Supplier 1",
      address: "Sampaloc, Apalit",
      category: "Masonry",
    },
    {
      id: 5,
      discount: 50,
      cover: "./images/flash/Copy of bb standard__1_-removebg-preview.png",
      name: "Mid Grade Cement",
      price: 100,
      supplier: "Supplier 1",
      address: "Sampaloc, Apalit",
      category: "Masonry",
    },
    {
      id: 6,
      discount: 50,
      cover: "./images/flash/Copy of ss high Stanley Fibreglass Claw Hammer ₱374.png",
      name: "Wood Handle Hammer",
      price: 374,
      supplier: "Supplier 1",
      address: "Sampaloc, Apalit",
      category: "Masonry",  
    },
    {
      id: 7,
      discount: 20,
      cover: "./images/flash/Steel bar.png",
      name: "Steels",
      price: 125,
      supplier: "Supplier 1",
      address: "Sampaloc, Apalit",
      category: "Steel",  
    },
    {
      id: 8,
      discount: 10,
      cover: "./images/flash/Copy of dd high-removebg-preview.png",
      name: "Boysen",
      price: 435,
      supplier: "Supplier 1",
      address: "Sampaloc, Apalit",
      category: "Masonry",  
    },
    {
      id: 9,
      discount: 30,
      cover: "./images/flash/Copy of cc mid-removebg-preview.png",
      name: "Mid Quality Gavanized Steel",
      price: 435,
      supplier: "Supplier 1",
      address: "Sampaloc, Apalit",
      category: "Steel",  
    },
    {
      id: 10,
      discount: 60,
      cover: "./images/flash/mid GI WIRE.png",
      name: "Mid Quality GI WIRE",
      price: 124,
      supplier: "Supplier 1",
      address: "Sampaloc, Apalit",
      category: "Steel",  
    },
  ],
}
export default Data
